import AssessmentOutlinedIcon from '@mui/icons-material/AssessmentOutlined';
// import RefreshIcon from '@mui/icons-material/Refresh';
import {
  Box,
  CircularProgress,
  Tooltip,
  Typography,
} from '@mui/material';

interface Props {
  loading: boolean;
  onOpen: () => void;
  onRefresh?: () => void;
}

const QuickViewButton = ({ loading, onOpen }: Props) => {
  return (
    <Box display="flex" alignItems="center" gap={0.5}>
      <Tooltip title="Quick View">
        <Box
          display="flex"
          alignItems="center"
          gap={0.5}
          sx={{
            cursor: loading ? 'default' : 'pointer',
            color: 'primary.main',
          }}
          onClick={!loading ? onOpen : undefined}
        >
          <AssessmentOutlinedIcon fontSize="small" />

          <Typography variant="body2" fontWeight={600}>
            Quick View
          </Typography>

          {loading && <CircularProgress size={16} thickness={5} />}
        </Box>
      </Tooltip>

      {/* <Tooltip title="Refresh">
        <span>
          <IconButton size="small" disabled={loading} onClick={onRefresh}>
            <RefreshIcon fontSize="small" />
          </IconButton>
        </span>
      </Tooltip> */}
    </Box>
  );
};

export default QuickViewButton;
